module.exports = __webpack_public_path__ + "static/img/step_04.19382ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/binding/img/step_04.jpg
// module id = v1Ky
// module chunks = 59